<template>
  <div>
    <li><a href="http://app.agrotec.devs:8080" class="link">App</a></li>
    <li><a href="http://apromalpi.agrotec.devs:8080" class="link">Apromalpi</a></li>
    <li><a href="http://asprobo.agrotec.devs:8080" class="link">Asprobo</a></li>
    <li><a href="http://fairtrasa.agrotec.devs:8080" class="link">Fairtrasa</a></li>
    <li><a href="http://iren.agrotec.devs:8080" class="link">Iren</a></li>
    <li><a href="http://asprobo.agrotec.devs:8080" class="link">Protecpak</a></li>
    <li><a href="http://rioyvalle.agrotec.devs:8080" class="link">Rio y Valle</a></li>
    <li><a href="http://asprobo.agrotec.devs:8080" class="link">Sol de Olmos</a></li>
  </div>
</template>
